var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var ownDataUsecaseNames = ['blank-sandbox', 'gsheets', 'graph-data-science-blank-sandbox'];
var featuredUsecasesNames = ['movies', 'openstreetmap', 'graph-data-science2', 'icij-offshoreleaks'];
var ArrayDiff = function (a, b) { return a.filter(function (x) { return !b.includes(x); }); };
export var generateUsecaseCategories = function (usecases, personaFilter) {
    var filteredUseCases = personaFilter ? usecases.filter(function (usecase) { return usecase.persona && usecase.persona.indexOf(personaFilter) > -1; }) : usecases;
    var bloomIndex = featuredUsecasesNames.indexOf('bloom');
    // Add bloom to featuredUsecase if DataScience filter is on, else remove
    if (personaFilter === 'data-scientist' && bloomIndex === -1) {
        featuredUsecasesNames.push('bloom');
    }
    else if (bloomIndex !== -1) {
        featuredUsecasesNames.splice(bloomIndex, 1);
    }
    var featuredUsecases = __spreadArray([], filteredUseCases.filter(function (e) { return featuredUsecasesNames.indexOf(e.name) > -1; }), true);
    var ownDataUsecases = __spreadArray([], filteredUseCases.filter(function (e) { return ownDataUsecaseNames.indexOf(e.name) > -1; }), true);
    var preBuiltDataUsecases = ArrayDiff(ArrayDiff((filteredUseCases), ownDataUsecases), featuredUsecases);
    var categories = [];
    if (featuredUsecases.length > 0) {
        categories.push({
            title: 'Featured Dataset',
            items: Array.from(featuredUsecases),
            itemsPerRow: 3,
        });
    }
    if (ownDataUsecases.length > 0) {
        categories.push({
            title: 'Your own data',
            items: Array.from(ownDataUsecases),
            itemsPerRow: 3,
        });
    }
    if (preBuiltDataUsecases.length > 0) {
        categories.push({
            title: 'Pre-built data',
            items: Array.from(preBuiltDataUsecases),
            itemsPerRow: 3,
        });
    }
    return categories;
};
export default {
    generateUsecaseCategories: generateUsecaseCategories,
};
